import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import AuthPage from "../components/auth/AuthPage";

const RegisterPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t("auth.register_meta_title")}</title>
      </Helmet>
      <AuthPage mode="register" />
    </>
  );
};

export default RegisterPage;
